import PageHeader from "@/components/PageHeader";
import MailCenter from "@/components/MailCenter";

export default function MailCenterPage() {
  return (
    <div className="space-y-6" data-testid="mail-center-page">
      <PageHeader
        title="Centro de correos"
        subtitle="Elegí qué correos automáticos salen, apagalos o pausalos hasta una fecha"
      />
      <MailCenter />
    </div>
  );
}
